import React from "react";

const TextModal = ({ ismodal, setismodal, heading, text }) => {
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full relative">
        {/* Close Button */}
        <button
          className="absolute top-2 right-3 text-gray-600 hover:text-black text-3xl"
          onClick={() => setismodal(false)}
        >
          &times;
        </button>

        {/* Heading */}
        <h2 className="text-xl font-bold mb-4 text-start">{heading}</h2>

        {/* Scrollable Content */}
        <div className="max-h-60 overflow-y-auto border p-3 rounded">
          <p className="text-gray-700 text-start">{text}</p>
        </div>
      </div>
    </div>
  );
};

export default TextModal;